import { createContext } from 'preact-compat'

interface PageContext {
  page: string
  breadcrumbs: Array<{
    title: string
    url: string
  }>
}

const CurrentPageContext = createContext<PageContext>({
  page: '404',
  breadcrumbs: []
})

export default CurrentPageContext
